import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import ModalBody from './ModalBody';
import { ExclamationCircleOutlined, EditOutlined, MailOutlined, SearchOutlined } from '@ant-design/icons';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = ({setModalVisible, modalVisible, setUpdate, update}) => {
  const [results, setResults] = useState([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');
  const { confirm } = Modal;

  useEffect(() => {
    window.searchText = '';
    window.tempResults = [];
    loadResults();
  }, []);

  const loadResults = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    try {
      const res = await axios.post(`${URL}/user/get_user.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        data.forEach((item, index) => {
          item.key = index
        });
        window.tempResults = data;
        //setResults(data);
        searchUsers();
      } else {
        alert(res.data.Message);
      }
    } catch(error) {
      console.log(error);

    }
  }

  const openEditModal = (user) => {
    setUpdate(update + 1);
    setEditModalVisible(true);
    setSelectedUser(user);
  }

  const sendResetLink = async (user) => {
    const bodyFormData = new FormData();
    bodyFormData.append('Email', user.Email);
   
    try {
        dispatch(enableSpinner('Sending..'));
        const res = await axios.post(`${URL}/login/forgot_password.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
        } else {
          message.error(res.data.Message);
        }
    } catch(error) {
      console.log(error);
      dispatch(disableSpinner());
    }
  }

  const handleSearch = (event) => {
    window.searchText = event.target.value;
    searchUsers();
  }

  function searchUsers() {
      setResults(window.tempResults.filter(item => item.Email.toLowerCase().includes(window.searchText.toLowerCase())));
  }

  const handleSubmit = async (values, index) => {
    if(!values.permanent && (values.endDate == "" || values.endDate == null)) {
      alert("Please input end date.");
      return;
    }
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    bodyFormData.append('Email', values.email);
    if(values.password) {
      bodyFormData.append('Password', values.password);
    }
    if(values.endDate != "" && values.endDate != null) {
      bodyFormData.append('EndDate', values.endDate);
    }
    bodyFormData.append('Type', values.permanent? 2: 1);
    bodyFormData.append('Elite', values.elite? 1: 0);

    try {
      if(index === 0) {
        setModalVisible(false);

        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/user/add_user.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      } else {
        setEditModalVisible(false);

        bodyFormData.append('Id', selectedUser.Id);

        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/user/update_user.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      }
    }catch(error) {
      console.log(error);
      dispatch(disableSpinner());
    }
  }

  const columns = [
    {
      title: 'Email',
      dataIndex: 'Email',
      key: 'Email',
    },
    {
      title: 'UserType',
      dataIndex: 'UserType',
      key: 'UserType',
    },
    {
      title: 'End Date',
      dataIndex: 'EndDate',
      key: 'EndDate',
    },
    {
      title: 'Edit',
      dataIndex: '',
      key: 'edit',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => openEditModal(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          <EditOutlined />
          </span>
        )
      }
    },
    {
      title: 'Send Password Reset Link',
      dataIndex: '',
      key: 'edit',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => sendResetLink(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          <MailOutlined />
          </span>
        )
      }
    },
  ]

  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <div className="search-box">
              <div className="search-icon">
                <SearchOutlined />
              </div>
              <input type="text" onChange={handleSearch} placeholder="Search users"/>
            </div>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }} 
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
      <Modal
        title={`Add User`}
        width="30%"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        footer={null}
      >
      <ModalBody close={() => setModalVisible(false)} handleSubmit={(values) => handleSubmit(values, 0)} update={update} />
      </Modal>

      <Modal 
        title="Edit User"
        width="30%"
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        footer={null}>
          <ModalBody 
            close={() => {setSelectedUser(null); setEditModalVisible(false); }} 
            handleSubmit={(values) => handleSubmit(values, 1)}
            user={selectedUser}
            update={update} />
        </Modal>
    </Col>
  );
}



export default ExampleCard;
